module.exports = __webpack_public_path__ + "static/media/pic2.b9523c93.jpg";